// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#app-receipt .edit-template {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n#app-receipt .receipt-avatar {\n  border: 1px solid #f1f2f5;\n  margin: 0 0 12px !important;\n}\n#app-receipt .card-form-dialog  {\n  background-color: #f3f3f3 !important;\n}\n#app-receipt .card-form-dialog .v-sheet {\n  background-color: inherit !important;\n}\n", ""]);
// Exports
module.exports = exports;
